export default __webpack_public_path__ + "static/media/ne.0b54800d.jpg";